import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type Amount from 'linced-app/models/finance/daily-summary/amount';
import type Till from 'linced-app/models/finance/daily-summary/till';

// Proto: finance.DailySummaryInSafe.
export default class InSafe extends Fragment {
  declare [Type]: 'finance/daily-summary/in-safe';

  @fragmentArray('finance/daily-summary/till')
  declare tills: FragmentArray<Till>;

  @fragmentArray('finance/daily-summary/amount')
  declare totals: FragmentArray<Amount>;
}
